import { EVENT } from '..';

const register = bus => {
	bus.subscribe(EVENT.CLIPLIST_ITEM_HOVER, item => {
		bus.publish(EVENT.TIMELINE_HIGHLIGHT_TAGS, [item && item.tag]);
	});
	bus.subscribe(EVENT.CLIPLIST_ITEM_UNHOVER, () => {
		bus.publish(EVENT.TIMELINE_HIGHLIGHT_CLEAR);
	});
};

export default register;
